import React, { Component, useRef } from 'react';
import { faHeart, faStar, faTrashCan, faPenToSquare  } from '@fortawesome/free-regular-svg-icons';
import { faCamera, faCalendar, faLock, faChartPie, faMagnifyingGlass, faArrowRight, faSpinner, faFileInvoice, faUsersLine, faBan, faBook, faFloppyDisk, faCashRegister } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, Link } from 'react-router-dom';
import EventHero from "./events/EventHero";
import HomeEventCards from "./events/HomeEventCards";
import StayConnected from './StayConnected';
import { MsalContext, useIsAuthenticated, AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, withMsal } from '@azure/msal-react';
import { Alert, Button, Modal, ModalHeader, ModalBody, ModalFooter, Toast, ToastHeader, ToastBody } from 'reactstrap';
import { loginRequest } from "../authConfig";
import Scan from './Scan';

export default function Home() {
    const scanRef = useRef(null);

    const handleScanClick = () => {
        if (scanRef && scanRef.current) {
            scanRef.current.handleStartScan();
        }
    }
    

    return (
        <>
            <div className="container py-0">
                <div className="row align-items-md-stretch pt-2 g-3">
                    <UnauthenticatedTemplate>
                        <div className="px-4 py-1 my-1 text-center">
                            <img className="d-block mx-auto mb-0" src="/assets/images/hyetech_logo2_4color.png" alt="" width="172" />
                            <h1 className="display-5 fw-bold text-body-emphasis mb-5">Welcome</h1>
                            <div className="col-lg-6 mx-auto">
                                <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                                    <LoginButton />
                                </div>
                            </div>
                        </div>
                    </UnauthenticatedTemplate>
                    <AuthenticatedTemplate>
                        <div className="col-md-6">
                            <div className="h-100 p-5 bg-body-tertiary border rounded-3">
                                <h2><FontAwesomeIcon icon={faCalendar} className="pe-2" />Events</h2>
                                <p>Manage events, event details and schedules.</p>
                                <Link to="/events" className="btn btn-outline-secondary me-1">Go to Events</Link>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="h-100 p-5 bg-body-tertiary border rounded-3">
                                <h2><FontAwesomeIcon icon={faCamera} className="pe-2" />Event Pass Scanner</h2>
                                <p>Scan event passes and verify redemption status.</p>
                                <Link onClick={handleScanClick} className="btn btn-outline-secondary me-1">Launch Scanner</Link>
                                <Scan ref={scanRef} />
                            </div>
                        </div>
                    </AuthenticatedTemplate>
                </div>
            </div>
        </>
    );
}
function LoginButton() {
    const { instance } = useMsal();

    const handleLogin = () => {
        instance.loginRedirect(loginRequest);
    }


    return (
        <Button color="primary" size="lg" className="px-4 gap-3" onClick={handleLogin}>
            <FontAwesomeIcon icon={faLock} className="me-2" />
            Login
        </Button>
    );
};

